<template>
  <div>
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        แจ้งปัญหาการใช้งาน
        <small></small>
      </h1>
      <ol class="breadcrumb">
        <li>
          <a href="#">
            <i class="fa fa-dashboard"></i> แจ้งปัญหาการใช้งาน
          </a>
        </li>
        <li class="active">แจ้งปัญหาการใช้งาน</li>
      </ol>
    </section>

    <section class="content">
      <transition name="page" mode="out-in">
        <div class="row">
          <div class="col-xs-12">
            <div class="box">
              <div class="box-header">
                <div class="wrapper_addtypegroup">
                  <el-form
                    size="mini"
                    :label-position="label_position"
                    label-width="150px"
                    ref="ruleForm"
                    class="demo-ruleForm"
                  >
                    <!-- <div class="row"> -->
                      <div class="col-md-12">
                        <el-form size="mini">
                            <el-form-item label="หัวข้อ">
                                <el-input v-model="form.subject"></el-input>
                            </el-form-item>
                            <el-form-item label="รายละเอียด">
                                <vue-editor v-model="form.content_th" :editor-toolbar="customToolbar"></vue-editor>
                            </el-form-item>
                        </el-form>
                      </div>
                    <!-- </div> -->
                    <div class="box-footer">
                      <el-button type="primary" @click="submitForm()">บันทึก</el-button>
                    </div>
                  </el-form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </section>
    <!-- /.content -->
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import { VueEditor } from "vue2-editor";
export default {
  components: {
    VueEditor
  },
  data() {
    return {
      label_position: "top",
      // form: {
      //     subject: '',
      //     content_th: ''
      // },
      customToolbar: [
        [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
        ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
        [{ 'align': '' }, { 'align': 'center' }, { 'align': 'right' }, { 'align': 'justify' }],
        [{ 'direction': 'rtl' }], 
        [{ 'list': 'ordered'}, { 'list': 'bullet' }],
        [{ 'indent': '-1'}, { 'indent': '+1' }],
        ['image', 'code-block'],
        ['clean']         
      ]
    };
  },
  created() {
    this.$store.dispatch('Manage_user/resetContactForm')
  },
  computed: {
    ...mapState({
        formProfile: store => store.Manage_user.formProfile,
        form: store => store.Manage_user.contact_form
    })
  },
  mounted() {},
  watch: {},
  methods: {
    ...mapActions({
        getUser: "Manage_user/getUser",
        sendProblem: "Manage_user/sendProblem"
    }),
    submitForm() {
        if(this.form.subject == "") {
          this.$confirm("กรุณากรอกหัวข้อ", "แจ้งเตือน", {
            confirmButtonText: "ตกลง",
            showCancelButton: false,
            type: "warning"
          })
          return false
        }
        if(this.form.content_th == "") {
          this.$confirm("กรุณากรอกรายละเอียด", "แจ้งเตือน", {
            confirmButtonText: "ตกลง",
            showCancelButton: false,
            type: "warning"
          })
          return false
        }
        let form = this.$cookies.get('user_nbtc')
        form.problem = this.form
        this.sendProblem(form);
    }
  }
};
</script>
